import { useEffect, useRef } from 'react'
import { Box } from '@mui/material'
import { Link } from '@reach/router'
import { useField } from 'formik'
import { t } from 'i18next'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import InfoBar from 'src/components/shared/ui/InfoBar/InfoBar'
import { OrganoDestinoFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/organoDestinoTypes'
import { ESCRITOS_LEXNET } from 'src/constants/routes'
import { useAlertContext } from 'src/contexts/AlertContext'
import { useTipoMensajeContext } from 'src/contexts/TipoMensajeContext'
import { TipoMensaje, TipoMensajeURLPath } from 'src/enums/EscritosLegales'
import { FormField } from 'src/enums/Form'
import { Materia } from 'src/interfaces/Catalog'

const CODIGO_MATERIA_MONITORIO = '102'

const styles = {
  fontWeight: 'bold',
  textDecoration: 'underline'
}

function MonitorioAviso(): JSX.Element | null {
  const { addAlert, closeAlert } = useAlertContext()
  const { changeTipoMensaje } = useTipoMensajeContext()
  const [materia] = useField<Materia | null>(FormField.DATOS_MATERIA)
  const [organoDestino] = useField<OrganoDestinoFormValues | null>(FormField.ORGANO_DESTINO)
  const lastMateriaAvisada = useRef<string | null>(null)

  const comunidad = organoDestino.value?.[FormField.COMUNIDAD_AUTONOMA]
  const esMateriaMonitorio = Boolean(
    materia.value?.codigo?.startsWith(CODIGO_MATERIA_MONITORIO) && comunidad?.monitorio
  )

  function handleClick() {
    changeTipoMensaje(TipoMensaje.MONITORIO)
    closeAlert()
  }

  function Message(): JSX.Element {
    return (
      <>
        {t('components.info_bar_monitorio.text')}{' '}
        <Link to={ESCRITOS_LEXNET(TipoMensajeURLPath.MONITORIO)} onClick={handleClick}>
          <span style={styles}>{t('components.info_bar_monitorio.link')}</span>
        </Link>
      </>
    )
  }

  useEffect(() => {
    if (!esMateriaMonitorio) {
      lastMateriaAvisada.current = null
      return
    }

    if (materia.value?.codigo !== lastMateriaAvisada.current) {
      lastMateriaAvisada.current = materia.value?.codigo ?? null
      addAlert({ type: AlertType.WARNING, message: <Message /> })
    }
    // eslint-disable-next-line
  }, [esMateriaMonitorio, materia.value?.codigo])

  if (!esMateriaMonitorio) {
    return null
  }

  return (
    <Box sx={{ marginTop: 0, marginBottom: '16px' }}>
      <InfoBar
        type={AlertType.WARNING}
        message={<Message />}
        iconVariant="info"
        showCloseIcon={false}
      />
    </Box>
  )
}

export default MonitorioAviso
